import { AxiosPromise } from "axios";
import { request } from "./request";
import { ClubMassPayload, ClubPayload } from "../types";

export const clubApi = {
  findAll: (params?: Record<string, any>): AxiosPromise<any> =>
    request({
      url: `content/clubs/page/${params?.page ?? 1}`,
      method: "get",
      params,
    }),

  detail: (id: string): AxiosPromise<any> =>
    request({
      url: `/content/clubs/${id}`,
      method: "get",
    }),

  create: (data: ClubPayload): AxiosPromise<any> =>
    request({
      url: "/content/clubs",
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  createMass: (data: ClubMassPayload[]): AxiosPromise<any> =>
    request({
      url: "/content/clubs/mass-create",
      method: "post",
      data: {
        clubs: data,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }),

  update: (id: string, data: ClubPayload): AxiosPromise<any> =>
    request({
      url: `/content/clubs/${id}/update`,
      method: "put",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/club/${id}`,
      method: "delete",
    }),

  updateStatus: (id: string, status: boolean): AxiosPromise<any> =>
    request({
      url: `/content/clubs/${id}/status`,
      method: "put",
      data: {
        is_active: status,
      },
    }),

  getTracking: (id: string, params?: any): AxiosPromise<any> =>
    request({
      url: `/content/clubs/${id}/history/page/${params?.page ?? 1}`,
      method: "get",
      params,
    }),
};
